export enum MediaSourceParams {
    VEND = 'vend',
    VBEGIN = 'vbegin',
};
